import { render, staticRenderFns } from "./color-bespoke-colors.vue?vue&type=template&id=5cf95ae1&scoped=true"
import script from "./color-bespoke-colors.vue?vue&type=script&lang=js"
export * from "./color-bespoke-colors.vue?vue&type=script&lang=js"
import style0 from "./color-bespoke-colors.vue?vue&type=style&index=0&id=5cf95ae1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf95ae1",
  null
  
)

export default component.exports